import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FileViewerComponent } from "../file-viewer/file-viewer.component";
import { Router } from "@angular/router";
import { RouterModule } from "@angular/router";

export interface ContactPillValue {
  id: number;
  name: string;
  type: "company" | "person" | "society";
}
@Component({
    selector: "app-contact-pill",
    imports: [
        CommonModule,
        RouterModule,
    ],
    templateUrl: "./contact-pill.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./contact-pill.component.css"]
})
export class ContactPillComponent {
  @Input("value") value: ContactPillValue | null = null;
  constructor(private router: Router) {}

  onPillClick() {
    if (!this.value) return;

    if (this.value.type === "company") {
      this.router.navigate([`/contacts/company/${this.value.id}`]);
    } else if (this.value.type === "society") {
      this.router.navigate([`/contacts/society/${this.value.id}`]);
    } else {
      this.router.navigate([`/contacts/person/${this.value.id}`]);
    }
  }
}
